import { faEnvelope } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Helmet } from 'react-helmet-async';
import { DefaultValues } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import type { IInvitationResponseFormValues } from '~/components/forms/InvitationResponseForm';
import { InvitationResponseForm } from '~/components/forms/InvitationResponseForm';
import { Heading } from '~/components/molecules/Heading';

export type IInvitationPageProps = {
  invitationId: string;
  defaultValues?: DefaultValues<IInvitationResponseFormValues>;
};

export const InvitationPage: React.FC<IInvitationPageProps> = (props) => {
  const { invitationId, defaultValues } = props;
  const { t } = useTranslation();

  return (
    <>
      <Helmet>
        <title>{t('InvitationPage.seo.title')}</title>
      </Helmet>

      <Heading
        icon={<FontAwesomeIcon icon={faEnvelope} />}
        title={t('InvitationPage.title')}
      />

      <InvitationResponseForm
        invitationId={invitationId}
        defaultValues={defaultValues}
        cancelUrl="/invitation-declined"
      />
    </>
  );
};
